import React from "react";
export const Mail = () => (
  <svg className="mail" version="1.2" viewBox="0 0 16 12" xmlns="http://www.w3.org/2000/svg">
    <g fill="var(--contrast-dark)">
      <path d="m16 1.81v0.5q-3.01 3.17-7.55 5.78a1 1 0 0 1-1.09-0.07c-1.39-1.02-8.53-5.25-6.4-7.23a1.01 0.99-66 0 1 0.68-0.27c2.77-0.02 12.9-0.9 14.36 1.29z"/>
      <path d="m14.44 12h-13q-1.46-2.61-0.88-5.98a1 1 0 0 1 1.57-0.64l5.33 3.79a1 0.99-45.2 0 0 1.16-0.01l5.52-3.95a1 1 0 0 1 1.54 0.51q1.04 3.37-1.24 6.28z"/>
    </g>
  </svg>
);
export default Mail;